import { render } from "./NavBarForSales.vue?vue&type=template&id=5dff65f6&scoped=true"
import script from "./NavBarForSales.vue?vue&type=script&lang=js"
export * from "./NavBarForSales.vue?vue&type=script&lang=js"

import "./NavBarForSales.vue?vue&type=style&index=0&id=5dff65f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dff65f6"]])

export default __exports__